import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { getModel } from '@smx-ui-model/store-model';
import { GenericModelSchemaType, StoreModelType, TableResourceType } from '@smx-ui-model/types';
import { Form } from 'antd';
import * as React from 'react';
import { memo, useEffect } from 'react';

interface InspectorProps {
    modelName: keyof StoreModelType;
    entity: TableResourceType;
}

const LoaderFormInspector: React.FC<InspectorProps> = ({ entity, modelName }) => {
    const form = Form.useFormInstance();
    const model = getModel<GenericModelSchemaType>(modelName);

    const dataEntity = useFragmentFromStore(entity.userRef) as any;

    useEffect(() => {
        const data: any = model.context ? {} : { ...dataEntity };

        if (model.context) {
            (model.context?.inspectorInputEdit || model.context?.inspectorInput)?.map((fieldName) => {
                data[fieldName] = model.loaderInspector?.[fieldName]?.(dataEntity[fieldName]) || dataEntity[fieldName];
            });
            model.context?.inspectorInputHide?.map((fieldName) => {
                data[fieldName] = model.loaderInspector?.[fieldName]?.(dataEntity[fieldName]) || dataEntity[fieldName];
            });
        }

        form.setFieldsValue(data);
    }, [dataEntity]);

    return <></>;
};

export default memo(LoaderFormInspector);
